import { Coordinates } from "@bennara/shared";
import { createSelectionRing } from "./utils/createSelectionRing";
import * as THREE from "three";

export class FocusedPointRing {
  private readonly movingRing = createSelectionRing(window.colors.primary);

  constructor() {
    this.movingRing.visible = false;
  }

  getRing(): THREE.Sprite {
    return this.movingRing;
  }

  show(): void {
    this.movingRing.visible = true;
  }

  hide(): void {
    this.movingRing.visible = false;
  }

  /** Selected mark. Stays the primary color so it is distinct from placement. */
  setSelectColor(): void {
    this.setColor(window.colors.primary);
  }

  /** Add or move. Same pin color as the draft sphere (`moleNew`). */
  setEditColor(): void {
    this.setColor(window.colors.moleNew);
  }

  private setColor(color: string): void {
    const prevPosition = this.movingRing.position.clone();
    this.movingRing.clear();
    this.movingRing.copy(createSelectionRing(color));
    this.movingRing.position.copy(prevPosition);
  }

  setPosition(position: THREE.Vector3): void {
    this.movingRing.position.copy(position);
  }

  moveToCoordinates(coordinates: Coordinates): void {
    this.movingRing.position.set(coordinates.x, coordinates.y, coordinates.z);
  }
}
